module.exports = __webpack_public_path__ + "media/images/pdf-a71ce577.svg";